/**
 * 监听滚动到底部
 * @param {Function} callback 回调函数
 * @example
 * <div v-scroll-bottom="callback"></div>
 * <el-scrollbar v-scroll-bottom:el-scrollbar="callback"></el-scrollbar> 容器为el-scrollbar 是增加 el-scrollbar 标识
 */

import { debounce } from '@/utils/api';

const scrollBottom = {
  mounted(el, binding) {
    // 标记当前是否正在向下滚动
    let isScrollingToBottom = false;
    const { arg } = binding;
    // el-scrollbar 特殊处理
    if (arg === 'el-scrollbar') {
      el = el.children[0];
    }

    const onScroll = () => {
      const scrollTop = el.scrollTop || document.documentElement.scrollTop;
      const clientHeight = el.clientHeight || document.documentElement.clientHeight;
      const scrollHeight = el.scrollHeight || document.documentElement.scrollHeight;

      // 允许有 20px 的误差
      if (!isScrollingToBottom && scrollHeight <= clientHeight + scrollTop + 10) {
        isScrollingToBottom = true;

        setTimeout(() => {
          isScrollingToBottom = false;

          // 调用传入的回调函数
          typeof binding.value === 'function' ? debounce(binding.value(), 1000) : null;
        }, 200); // 设置一个合理的时间间隔，防止连续多次触发事件
      }
    };

    el.addEventListener('scroll', onScroll, { passive: true });

    // 在卸载指令时移除事件监听
    el._onScroll = onScroll; // 存储引用，以便后面可以移除事件监听
  },
  unmounted(el, binding) {
    const { arg } = binding;
    // el-scrollbar 特殊处理
    if (arg === 'el-scrollbar') {
      el = el.children[0];
    }
    el.removeEventListener('scroll', el._onscroll);
  }
};

export default scrollBottom;
